import { Component, OnInit,Input , Output, EventEmitter, Inject, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../core/services/auth.service';
import Swal from 'sweetalert2';
import { LandaService } from '../../core/services/landa.service';


@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
    element;
    configData;
    user: any;
    model: {
        id;
        kode;
        nama;
        password;
        repassword;
    };
    title;

    // ==== WhatsApp / Connect Channel (UI only, dummy) ====
    /** Apakah channel WhatsApp sudah terhubung. Dummy state, defaultnya belum. */
    waConnected = false;
    /** Step form connect channel: 1 = isi data channel, 2 = scan QR, 4 = info terhubung (3/sukses pakai Swal) */
    connectStep = 1;
    connectModel: { platform: string; channelName: string; aiAgent: string };
    platformList = ['WhatsApp'];
    aiAgentList = ['Humanis Agent'];
    /** Info akun WhatsApp yang terhubung (dummy). */
    connectedInfo: { accountName: string; phone: string; lastConnected: string } = {
        accountName: '',
        phone: '',
        lastConnected: '',
    };
    /** Daftar konteks chat yang dapat dibalas otomatis oleh AI Agent (dummy). */
    agentContexts = [
        { title: 'Informasi Absensi', desc: 'Menjawab pertanyaan seputar kehadiran, jam masuk, dan jam pulang karyawan.', sample: 'Halo, jam berapa saya absen masuk hari ini?', response: 'Hai! Hari ini kamu absen masuk pukul 08.02 WIB. Semangat bekerja! 😊', expanded: false },
        { title: 'Pengajuan Cuti & Izin', desc: 'Membantu pengajuan cuti/izin dan mengecek sisa cuti tahunan.', sample: 'Saya mau ajukan cuti tanggal 10-12 Juli, sisa cuti saya berapa?', response: 'Sisa cuti tahunan kamu 8 hari. Pengajuan cuti 10-12 Juli sudah saya catat dan diteruskan ke atasan untuk persetujuan.', expanded: false },
        { title: 'Slip Gaji', desc: 'Mengirimkan slip gaji terbaru karyawan.', sample: 'Tolong kirimkan slip gaji saya bulan ini.', response: 'Baik, slip gaji bulan ini sudah saya kirimkan ke email kamu ya. 📄', expanded: false },
        { title: 'Reimbursement', desc: 'Mengecek status dan membantu pengajuan reimbursement.', sample: 'Bagaimana status pengajuan reimbursement saya?', response: 'Pengajuan reimbursement kamu sebesar Rp350.000 sedang dalam proses review oleh Finance.', expanded: false },
        { title: 'Pengumuman', desc: 'Menyampaikan informasi dan pengumuman perusahaan.', sample: 'Apakah ada pengumuman terbaru dari HR?', response: 'Ada 1 pengumuman baru: "Libur Cuti Bersama Idul Fitri 21 Maret 2026". Cek detailnya di aplikasi ya.', expanded: false },
    ];

    constructor(
        @Inject(DOCUMENT) private document: any,
        private router: Router,
        private modalService: NgbModal,
        private authService: AuthenticationService,
        private landaService: LandaService,

    ) {}

    openMobileMenu: boolean;

    @Output() settingsButtonClicked = new EventEmitter();
    @Output() mobileMenuButtonClicked = new EventEmitter();

    ngOnInit() {
        this.openMobileMenu = false;
        this.element = document.documentElement;

        this.configData = {
            suppressScrollX: true,
            wheelSpeed: 0.3,
        };

        this.user = this.authService.getDetailUser();
        this.title = 'Dashboard';
        
    }
    // ngAfterViewInit() {
    //     this.title = localStorage.getItem("title");
    // }
    setTitle($event){
        this.title = $event; 
    }
    gantiPassword(modal) {
        this.modalService.open(modal, { size: 'md', backdrop: 'static'  });
        this.model =  {
            id: '',
            kode: '',
            nama: '',
            password: '',
            repassword: '',
        };
    }
    savepasswords() {
        const data = {
            model : this.model,
        };
        this.landaService.customAlert(
            'warning',
            'Apakah anda yakin ?',
            'Mengubah password anda',
            true,
            true,
            'Ya, ubah password !'
        ).then(result => {
            if (result.value) {
                this.landaService.DataPost('/appkaryawan/updatepassword', data).subscribe((res: any) => {
                    if (res.status_code === 200) {
                        this.landaService.alertSuccess('Berhasil', 'Password telah diubah !');
                    } else {
                        this.landaService.alertError('Mohon Maaf', res.errors);
                    }
                });
            }
        });
    }
    /**
     * Buka popup Connect Channel (WhatsApp). Reset ke step 1.
     * Jika belum pernah connect, Platform & AI Agent otomatis terisi dan
     * user hanya perlu mengisi Channel Name.
     */
    openConnectChannel(modal) {
        if (this.waConnected) {
            // Sudah terhubung -> tampilkan info akun WhatsApp.
            this.connectStep = 4;
        } else {
            // Belum pernah connect -> form step 1.
            this.connectStep = 1;
            this.connectModel = {
                platform: this.platformList[0],   // WhatsApp, langsung terpilih
                // Channel Name otomatis terisi sesuai nama perusahaan.
                channelName: (this.user && this.user.m_perusahaan && this.user.m_perusahaan.nama) || '',
                aiAgent: this.aiAgentList[0],      // dummy Humanis Agent, otomatis terpilih
            };
        }
        this.modalService.open(modal, { size: 'lg', backdrop: 'static', centered: true, scrollable: true });
    }

    /**
     * Submit step 1 -> lanjut ke step 2 (scan QR).
     */
    connectChannelNext() {
        if (!this.connectModel || !this.connectModel.channelName) {
            return;
        }
        this.connectStep = 2;
    }

    /**
     * Simulasi QR berhasil di-scan / channel terhubung (UI only).
     * Menandai channel sebagai terhubung, mengisi info dummy, dan
     * menampilkan step sukses.
     */
    simulateConnected() {
        this.waConnected = true;
        this.connectedInfo = {
            accountName: (this.connectModel && this.connectModel.channelName) || 'Humanis Hiraka',
            phone: '+62 812-3456-7890',
            lastConnected: '1 Juli 2026, 09:30',
        };
        // Tutup modal connect lalu tampilkan notif sukses kecil yang
        // otomatis tertutup dalam 5 detik (tanpa tombol).
        this.modalService.dismissAll();
        Swal.fire({
            icon: 'success',
            title: 'WhatsApp Terhubung',
            html: 'Channel <strong>' + this.connectedInfo.accountName + '</strong> berhasil terhubung.',
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
        });
    }

    /** Reconnect / putuskan koneksi -> buka form QR lagi (UI only). */
    reconnectChannel() {
        this.connectStep = 2;
    }

    /**
     * Action logout
     */
    logout() {
        this.landaService
            .DataGet('/site/logout', {})
            .subscribe((res: any) => {
                this.authService
                    .logout()
                    .then((res: any) => {
                        window.location.reload();
                        // this.router.navigate(['/account/login']);
                    })
                    .catch((error) => {});
            });
    }
    /**
     * Toggles the right sidebar
     */
    toggleRightSidebar() {
        this.settingsButtonClicked.emit();
    }

    /**
     * Toggle the menu bar when having mobile screen
     */
    toggleMobileMenu(event: any) {
        event.preventDefault();
        this.mobileMenuButtonClicked.emit();
    }

    /**
     * Fullscreen method
     */
    fullscreen() {
        document.body.classList.toggle('fullscreen-enable');
        if (
            !document.fullscreenElement &&
            !this.element.mozFullScreenElement &&
            !this.element.webkitFullscreenElement
        ) {
            if (this.element.requestFullscreen) {
                this.element.requestFullscreen();
            } else if (this.element.mozRequestFullScreen) {
                /* Firefox */
                this.element.mozRequestFullScreen();
            } else if (this.element.webkitRequestFullscreen) {
                /* Chrome, Safari and Opera */
                this.element.webkitRequestFullscreen();
            } else if (this.element.msRequestFullscreen) {
                /* IE/Edge */
                this.element.msRequestFullscreen();
            }
        } else {
            if (this.document.exitFullscreen) {
                this.document.exitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
                /* Firefox */
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
                /* Chrome, Safari and Opera */
                this.document.webkitExitFullscreen();
            } else if (this.document.msExitFullscreen) {
                /* IE/Edge */
                this.document.msExitFullscreen();
            }
        }
    }
}
